import pcHttp from 'src/core/http'
import {ConsumerKey, IConsumer, mapConsumerFromApi, mapConsumersFromApi} from 'src/type/consumer'
import {IPagination} from 'src/type/paginated'
import {IUser, mapUsersFromApi} from 'src/type/user'
import {UserCriteria} from 'src/type/criteria/userCriteria'
import {IFundraise, mapFundraisesPaginationFromApi} from 'src/type/enterprise/fundraise'
import { NewsCriteria } from 'src/type/criteria/newsCriteria'
import { mapNewsPaginationFromApi, INews, mapCloudsFromApi, mapNewsFromApi } from 'src/type/news'
import { fundraisesSearchQuery } from 'src/core/graphql/fundraiseQuery'
import { ICategory, mapCategoriesFromApi } from 'src/type/category'
import { IContextLoanequity } from 'src/type/context-loanequity'
import { ISignature, mapSignaturePaginationFromApi } from 'src/type/signature'
import { SignatureCriteria } from 'src/type/criteria/signatureCriteria'
import { DocumentCriteria } from 'src/type/criteria/documentCriteria'
import { ProductCriteria } from 'src/type/criteria/productCriteria'
import { IProduct, mapProductPaginationFromApi, mapProductFromApi, IProductType } from 'src/type/product'
import { IDocument } from 'src/type/document'
import { ICotation, mapCotationPaginationFromApi, ICotationComment, mapCotationCommentPaginationFromApi } from 'src/type/cotation'
import { CotationCriteria } from 'src/type/criteria/cotationCriteria'
import { Criteria } from 'src/type/criteria/criteria'
import { TransactionCriteria } from 'src/type/criteria/transactionCriteria'
import { ITransactionChange, ITransactionPlacement, ITransactionDette, mapTransactionPaginationFromApi } from 'src/type/transaction'
import { IPage } from 'src/type/page'
import { PublicProductCriteria } from 'src/type/criteria/publicProductCriteria'
import { IPublicProduct, mapPublicProductPaginationFromApi } from 'src/type/public-product'



export const route = {
  consumer: {
    getAll: (): Promise<IConsumer[]> => pcHttp.get(`/app/consumer`).then(mapConsumersFromApi),
    get: (key: ConsumerKey): Promise<IConsumer> => pcHttp.get(`/app/${key}/consumer`).then(mapConsumerFromApi),
  },
  accountInfos: {
    get: (): Promise<any> => pcHttp.get(`account`),
    update: (data): Promise<any> => pcHttp.post(`account`, data),
    updatePassword: (newPassword): Promise<any> => pcHttp.post(`password`, newPassword),
    acceptCgu: (id: string, data: any): Promise<any> => pcHttp.post(`/enterprise/${id}/cgu?allow_mail_notifications=${data.allow_mail_notifications}`),
  },
  enterprise: {
    get: (id: string): Promise<any> => pcHttp.get(`/enterprise/${id}`),
    update: (id: string, data: any): Promise<any> => pcHttp.post(`/enterprise/${id}`, data),
    toggleMember: (eid: string, uid: string): Promise<any> => pcHttp.post(`/enterprise/${eid}/member/${uid}`, {}),
    getMembers: (id: string, c: UserCriteria): Promise<IPagination<IUser>> => pcHttp.get(`/enterprise/${id}/members`, c).then(mapUsersFromApi),
  },
  newsletter: {
    send: (data: any, enterpriseId: string): Promise<any> => pcHttp.post(`/enterprise/${enterpriseId}/newsletter`, data)
  },
  form: {
    get: (id: string, version: number): Promise<any> => pcHttp.get(`/enterprise/${id}/form/${version}`),
    update: (id: string, version:number, answers: any): Promise<any> => pcHttp.post(`/enterprise/${id}/form/${version}`, answers),
    getFormVersion: (id: string): Promise<{version: number}> =>pcHttp.get(`/enterprise/${id}/form/qp-version`)
  },
  news: {
    search: (c: NewsCriteria): Promise<IPagination<INews>> => pcHttp.get(`/news`, c).then(x => mapNewsPaginationFromApi(x.data.newsfeeds)),
    searchFeatured: (c: object): Promise<INews> => pcHttp.get(`/news`, c).then(x => mapNewsFromApi(x.data.newsfeeds.data[0])),
    searchFeaturedPrevent: (c: object): Promise<INews> => pcHttp.get(`/news`, c).then(x => mapNewsFromApi(x.data.newsfeeds.data[0])),
    get: (id: string): Promise<INews> => pcHttp.get(`/news/${id}`).then(mapNewsFromApi),
    getCloud: (c: NewsCriteria): Promise<any> => pcHttp.get(`/news/nuage`, c).then(mapCloudsFromApi),
  }, 
  category: {
    fetch: (): Promise<ICategory[]> => pcHttp.get(`/categories`).then(mapCategoriesFromApi),
  },
  signature: {
    searchDocToSign: (enterpriseId: string, c: SignatureCriteria) : Promise<IPagination<ISignature>> => pcHttp.get(`/enterprise/${enterpriseId}/document/to-sign`, c).then(mapSignaturePaginationFromApi),
    searchDocNotToSign: (enterpriseId: string, c: DocumentCriteria) : Promise<IPagination<ISignature>> => pcHttp.get(`/enterprise/${enterpriseId}/document/not-to-sign`, c).then(mapSignaturePaginationFromApi),
    searchDocSigned: (enterpriseId: string, c: SignatureCriteria) : Promise<IPagination<ISignature>> => pcHttp.get(`/enterprise/${enterpriseId}/signatures`, c).then(mapSignaturePaginationFromApi),
    getUrlToSign: (enterpriseId: string, docId: string) : Promise<any> => pcHttp.post(`/enterprise/${enterpriseId}/document/${docId}/sign`),
    getUrlDocument: (enterpriseId: string, docId: string) : Promise<any> => pcHttp.get(`/enterprise/${enterpriseId}/document/${docId}/url`),
  },
  products: {
    search: (enterpriseId: string, c: ProductCriteria): Promise<IPagination<IProduct>> => pcHttp.get(`/enterprise/${enterpriseId}/product`, c).then(mapProductPaginationFromApi),
    get: (enterpriseId: string, id: string): Promise<IProduct> => pcHttp.get(`/enterprise/${enterpriseId}/product/${id}`).then(mapProductFromApi),
    getByType: (enterpriseId: string, type: string): Promise<IProduct> => pcHttp.get(`/enterprise/${enterpriseId}/product/product_type/${type}`).then(mapProductFromApi),
    getDocs: (id: string): Promise<IDocument[]> => pcHttp.get(`/product/${id}/docs`),
    getProductType: (): Promise<IProductType[]> => pcHttp.get(`/product-types`)
  },
  publicProducts: {
    search: (c: PublicProductCriteria): Promise<IPagination<IPublicProduct>> => pcHttp.get(`/public-product`, c).then(mapPublicProductPaginationFromApi),
    getById: (id: string): Promise<IPublicProduct> => pcHttp.get(`/public-product/${id}`),
  },
  cotation: {
    get: (enterpriseId: string, productType: string, id: string): Promise<ICotation> => pcHttp.get(`/enterprise/${enterpriseId}/cotation/${productType}/${id}`),
    create: (data: any, enterpriseId: string, productType: string): Promise<ICotation> => pcHttp.put(`/enterprise/${enterpriseId}/cotation/${productType}`, data),
    update: (data: any, enterpriseId: string, productType: string, id: string): Promise<ICotation> => pcHttp.post(`/enterprise/${enterpriseId}/cotation/${productType}/${id}`, data),
    duplicate: (enterpriseId: string, productType: string, id: string): Promise<any> => pcHttp.post(`/enterprise/${enterpriseId}/cotation/${productType}/${id}/duplicate`, {}),
    getUsersToNotify: (enterpriseId: string, productType: string, c?: any): Promise<IPagination<IUser>> => pcHttp.get(`/enterprise/${enterpriseId}/cotation/${productType}/users`, c).then(mapUsersFromApi),
    getUserNotify: (ids: string): Promise<IUser[]> => pcHttp.get(`/user/${ids}`),
    getHistory: (enterpriseId: string, productType: string, id: string, c: Criteria): Promise<any> => pcHttp.get(`/enterprise/${enterpriseId}/cotation/${productType}/${id}/history`, c),
    addComment: (msg: any, enterpriseId: string, productType: string, id: string): Promise<any> => pcHttp.put(`/enterprise/${enterpriseId}/cotation/${productType}/${id}/comment`, msg),
    getComments: (c?: any) : Promise<IPagination<ICotationComment>> => pcHttp.get(`/news`, c).then(x => mapCotationCommentPaginationFromApi(x.data.newsfeeds)),
  },
  cotations: {
    fetch: (enterpriseId: string, c?: CotationCriteria): Promise<IPagination<ICotation>> => pcHttp.get(`/enterprise/${enterpriseId}/cotation`, c).then(mapCotationPaginationFromApi),
  },
  document: {
    upload: (document: any): Promise<any> => pcHttp.post(`/document/upload`, document),
    send: (enterpriseId: string, data: any): Promise<any> => pcHttp.post(`/enterprise/${enterpriseId}/document`, data)
  },
  transactions: {
    fetchChange: (enterpriseId: string, c: TransactionCriteria): Promise<IPagination<ITransactionChange>> => pcHttp.get(`/enterprise/${enterpriseId}/transaction/change`, c).then(mapTransactionPaginationFromApi),
    fetchDette: (enterpriseId: string, c: TransactionCriteria): Promise<IPagination<ITransactionDette>> => pcHttp.get(`/enterprise/${enterpriseId}/transaction/dette`, c).then(mapTransactionPaginationFromApi),
    fetchPlacement: (enterpriseId: string, c: TransactionCriteria): Promise<IPagination<ITransactionPlacement>> => pcHttp.get(`/enterprise/${enterpriseId}/transaction/placement`, c).then(mapTransactionPaginationFromApi),
    getDoc: (enterpriseId: string, transactionId: string): Promise<any> => pcHttp.post(`/enterprise/${enterpriseId}/document/${transactionId}/`),
  },
  pages: {
    get: (url: string): Promise<IPage> => pcHttp.get(`/page/${url}/json`)
  }
};

export const consumerRoute = (key: ConsumerKey) => {
  const base = `/app/${key}`;
  return {
    user: {
      search: (c?: UserCriteria): Promise<IPagination<IUser>> => pcHttp.get(`${base}/user/search`, c).then(mapUsersFromApi),
    },
    fundraises: {
      search: (c?: UserCriteria): Promise<IPagination<IFundraise>> => pcHttp.post(`${base}/graphql`, {
        fundraisesSearchQuery,
        variables: c
      }).then(x => mapFundraisesPaginationFromApi(x.data.fundraise_searchs)),
    },
    context: {
      getLoanequity: (): Promise<IContextLoanequity> => pcHttp.get(`${base}/context/loan-equity`),
      postLoanequity: (c: IContextLoanequity): Promise<IContextLoanequity> => pcHttp.post(`${base}/context/loan-equity`, c),
    },
  }
};



// WEBPACK FOOTER //
// ./src/conf/routes.ts